// Core Block Categories

export default [
  {
    slug: "basic",
    label: "Basic",
    priority: 100,
    expanded: true,
  },
  {
    slug: "layout",
    label: "Layout",
    priority: 90,
  },
  {
    slug: "site",
    label: "Site",
    priority: 70,
  },
  {
    slug: "cms",
    label: "CMS",
    priority: 60,
  },
  {
    slug: "directory",
    label: "Directory",
    priority: 60,
  },
  {
    slug: "content-locker",
    label: "Content Locker",
    priority: 60,
  },
  {
    slug: "cms-category",
    label: "CMS Category",
    priority: 60,
  },
  {
    slug: "form",
    label: "Form",
    priority: 60,
  },
  {
    slug: "portal",
    label: "Portal",
    priority: 60,
  },
  {
    slug: "miscellaneous",
    label: "Miscellaneous",
    priority: 50,
  },
];
